import React from 'react';

import { featureType } from 'types';
import './style.scss';

const FeatureItem = ({ feature: { key, parent, value } }) => (
  <tr>
    <td data-test="feature-title" styleName="key">
      {key} {parent && <sup title={parent}>(R)</sup>}
    </td>
    <td data-test="feature-value" styleName="value">
      {value}
    </td>
    <td styleName="icons">
      {!!value && <i className="icon-accept" data-test="feature-icon" />}
    </td>
  </tr>
);

FeatureItem.propTypes = {
  /* eslint-disable react/no-typos */
  feature: featureType.isRequired,
};

export default FeatureItem;
